import React, { createContext, useContext, useState } from "react";
import { toast } from 'react-toastify';
import { fetchUserIPSettingTableAndFilterSchema } from "model/UserIPSettingsModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const UserIPSettingsContext = createContext();

export const UserIPSettingsProvider = ({ children }) => {
    const { fetchMetadataSchema } = useCommonFilterOptions();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [userIPSettingsContextData, setUserIPSettingsContextData] = useState();

    const fetchUserIPSettingsContextData = async () => {
        setLoading(true);
        try {
            const response = await fetchMetadataSchema("metadata:userIPSetting", () =>
                fetchUserIPSettingTableAndFilterSchema([])
            );
            if (response?.success) {
                setUserIPSettingsContextData(response?.data);
            }
        } catch (err) {
            toast.error(err);
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <UserIPSettingsContext.Provider
            value={{ fetchUserIPSettingsContextData, userIPSettingsContextData, loading, error }}
        >
            {children}
        </UserIPSettingsContext.Provider>
    );
};

export const useUserIPSettingsContext = () => useContext(UserIPSettingsContext);
